import { Link } from 'react-router-dom';
import { categories, videos } from '@/mocks/videos';
import VideoCard from '@/components/base/VideoCard';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              分类浏览
            </h2>
            <p className="text-sm text-foreground-500 mt-2">按类型发现你感兴趣的内容</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4 mb-10">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-50 hover:bg-primary-50 transition-colors cursor-pointer group"
              >
                <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                </span>
                <span className="font-heading font-semibold text-sm text-foreground-800">
                  {cat.name}
                </span>
                <span className="text-xs text-foreground-500 text-center leading-relaxed hidden sm:block">
                  {cat.description}
                </span>
              </Link>
            ))}
          </div>

          {categories.map((cat) => {
            const catVideos = videos.filter((v) => v.category === cat.slug).slice(0, 4);
            if (catVideos.length === 0) return null;
            return (
              <div key={cat.slug} className="mb-10 last:mb-0">
                <div className="flex items-center justify-between mb-5">
                  <h3 className="font-heading font-semibold text-lg text-foreground-900">
                    <i className={`${cat.icon} mr-2 text-primary-600`}></i>
                    {cat.name}
                  </h3>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-xs text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap"
                  >
                    全部 <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
                  {catVideos.map((video) => (
                    <VideoCard key={video.id} video={video} />
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}